"use client";

import React from "react";
import GenericSubstantiveProcedures from "../../substantive-procedures/GenericSubstantiveProcedures";

interface RelatedPartyDisclosureSubstantiveProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
}

const WORKSPACE_NAME = "Related Party Disclosure";

export default function RelatedPartyDisclosureSubstantive({ onBack, setActiveSection }: RelatedPartyDisclosureSubstantiveProps) {
  return (
    <GenericSubstantiveProcedures
      workspaceName={WORKSPACE_NAME}
      area="Execution"
      onBack={onBack}
      setActiveSection={setActiveSection}
    />
  );
}
